"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var ProgramCard = function ProgramCardComponent(_ref) {
  var _ref$cardItem = _ref.cardItem,
      cardTitle = _ref$cardItem.card_title,
      cardImage = _ref$cardItem.card_image,
      cardBody = _ref$cardItem.card_body,
      dataClient = _ref.dataClient;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__program-card"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "content-page__program-card-image",
    src: cardImage.url,
    alt: "".concat(dataClient.renderText(cardTitle))
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__program-card-description-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "content-page__program-card-title"
  }, dataClient.textToMarkdown(cardTitle)), /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__program-card-body",
    content: cardBody
  })));
};

ProgramCard.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  cardItem: _propTypes["default"].shape({
    card_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    card_image: _propTypes["default"].shape({}).isRequired,
    card_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    card_title_alignment: _propTypes["default"].string
  }).isRequired
};
var _default = ProgramCard;
exports["default"] = _default;